import type { DocMigration } from "../docMigration";

/**
 * Snapshot of directly lockable entity types at the time of this migration.
 * Do not import lockableEntityTypes — migrations must stay isolated from future type changes.
 */
const LOCKABLE_ENTITY_TYPES: { readonly [type: string]: true } = {
  GROUP: true,
  LEVEL: true,
  UNDERLAY: true,
  STAIR_SYSTEM: true,
  STAIR_BLOCK: true,
  REFERENCE_GEOM: true,
  BLOCK: true,
  ROOM: true,
  MEASUREMENT: true,
  FOUNDATION_SYSTEM: true,
  FLOOR_SYSTEM: true,
  ROOF_SYSTEM: true,
  RAILING: true,
};

const migration: DocMigration = {
  id: "20260803_remove_non_lockable_from_locked",
  description: "Remove non-lockable entity handles from doc.locked",
  apply(json: any) {
    const locked = json.locked;
    if (!locked || typeof locked !== "object") {
      return json;
    }

    for (const hash of Object.keys(locked)) {
      const handle = locked[hash];
      if (!handle?.type || !LOCKABLE_ENTITY_TYPES[handle.type]) {
        delete locked[hash];
      }
    }

    return json;
  },
};

export default migration;
